import React from 'react';
import './errorMessage.scss';

interface ErrorProps {
    iconName?: string,
    errorText: string
}

const ErrorMessage = ({ iconName, errorText }: ErrorProps) => {
    return (
        errorText ? (
            <div className="error-text-section">
                <span className="material-icons-outlined">{iconName}</span>
                <span className="error-text">{errorText}</span>
            </div>
        ) : null
    );
}

export default React.memo(ErrorMessage);